import React from 'react';

import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { getThemeImages } from '../../../Themes';
import PaymentFooter from '../../Components/PaymentFooter';

import getPaymentFooterConfig from './PaymentFooterConfig';

const PaymentFooterContainer = ({
  theme,
  screen,
  paymentCards,
  successBtnID,
  renderCustomPaymentMethod,
  ...props
}) => {
  const darkIcon = getThemeImages(theme.name);
  const options = getPaymentFooterConfig(props);

  return (
    <>
      {options[screen] && (
        <PaymentFooter
          {...options[screen]}
          paymentCards={paymentCards}
          icon={darkIcon.edit_pen}
          renderCustomPaymentMethod={renderCustomPaymentMethod}
        />
      )}
    </>
  );
};
PaymentFooterContainer.defaultProps = {
  theme: LightThemeColors,
};
PaymentFooterContainer.propTypes = {
  ...PaymentFooter.propTypes,
};
export default withTheme(PaymentFooterContainer);
